import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { EXCHNAGE_URL } from '../../../../../Url/Url';
import axios from 'axios';
import { toast } from 'react-toastify';
import { GreyBackgroundButton, GreyBorderButton, RedBackgroundButton } from '../../../../Global/GlobalButton';
import FormCanvas from '../../../../Admin-Creating-New-Event/MyEvents/RegistrationForm/RegistrationChild/FormCanvas';
import FormPreview from '../../../../Admin-Creating-New-Event/MyEvents/RegistrationForm/RegistrationChild/FormPreview';
import SavedForm from '../../../../Admin-Creating-New-Event/MyEvents/RegistrationForm/RegistrationChild/SavedForm';
import Side from '../../../../Admin-Creating-New-Event/MyEvents/RegistrationForm/RegistrationChild/Side';
import { removeFieldFromPayload, resetState, SET_REGISTRATION_FORM_ID } from '../../../../Redux/Users/action';
import UpdateFormPreview from '../../../../Admin-Creating-New-Event/MyEvents/RegistrationForm/RegistrationChild/UpdateFormPreview';
import { setFieldPayload } from '../../../../Redux/Users/fieldAction';



export const UpdateRegistrationForm = ({ regFormSchema , setSelectedButton, updatedField , setShowFormOne}) => {
  const [fields, setFields] = useState([]); 
  const [showModal, setShowModal] = useState(false);
  const [showSavedForm, setShowSavedForm] = useState(false); 
  const [savedFormId, setSavedFormId] = useState(null); 
  const [addedFields, setAddedFields] = useState([])
  const [formSchema, setFormSchema] = useState([]); 
  const [copiedFields, setCopiedFields] = useState([]); 
  const [formData, setFormData] = useState([]);
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [draggedCategory, setDraggedCategory] = useState(null);
  

  const dispatch = useDispatch();
  const eventIdGet = useSelector((state) => state?.users?.id);
  const eventId = String(eventIdGet); 
  const fieldPayload = useSelector((state) => state.field.fieldPayload);
    const registrationFormId = useSelector((state) => state?.users?.registrationFormId);
  
  console.log(regFormSchema,"11sdfsdf1")
  const defaultFields = [
    {
      type: "text",
      label: "First Name (Default)",
      dataName: `firstName-${Date.now()}`,
      placeholder: "Enter first name...",
      required: true,
      visible: true,
      isDefault: true,
    },
    {
      type: "text",
      label: "Last Name (Default)",
      dataName: `lastName-${Date.now()}`,
      placeholder: "Enter last name...",
      required: true,
      visible: true,
      isDefault: true,
    },
    {
      type: "email",
      label: "Email (Default)",
      dataName: `emailDef-${Date.now()}`,
      placeholder: "Enter email...",
      required: true,
      visible: true,
      isDefault: true,
    },
    {
      type: "country",
      label: "Country (Default)",
      dataName: `countryDef-${Date.now()}`,
      options: ["USA", "India", "Canada"],
      required: true,
      visible: true,
      isDefault: true,
    },
  ];

console.log(regFormSchema,"hello")
const addField = (type) => {
  const newField = {
    label: {
      type: "hidden",
      label: "Label Text",
      required: false,
      visible: true,
      dataName: `label-${Date.now()}`,
      adminLabel: "Label Admin Label",
      description: "<p>This is an HTML description for the label.</p>",
      size: "h1",
      required: false,
      visible: true,
    },
    text: {
      type: "text",
      label: "Single Line Text",
      dataName: `text-${Date.now()}`,
      placeholder: "Enter text...",
      required: false,
      visible: true,
      charLimitRequired: false,
      wordLimit: "",
      fieldSize: "100%",
    },
    textarea: {
      type: "textarea",
      label: "Paragraph Text",
      dataName: `textarea-${Date.now()}`,
      charLimitRequired: false,
      required: false,
      visible: true,
      wordLimitRequired: false,
      charLimit: "",
      wordLimit: "",
      fieldSize: "100%",
    },
    radio: {
      type: "radio",
      label: "Radio Button",
      required: false,
      visible: true,
      dataName: `radio-${Date.now()}`,
      options: ["Option 1", "Option 2"],
    },
    checkbox: {
      type: "checkbox",
      label: "Checkbox",
      required: false,
      visible: true,
      dataName: `checkbox-${Date.now()}`,
      options: ["Option 1", "Option 2"],
    },
    dropdown: {
      type: "dropdown",
      label: "Dropdown",
      required: false,
      visible: true,
      dataName: `dropdown-${Date.now()}`,
      options: ["Option 1", "Option 2", "Option 3"],
    },
    email: {
      type: "email",
      label: "Email",
      required: false,
      visible: true,
      dataName: `email-${Date.now()}`,
      placeholder: "Enter email...",
    },
    tel: {
      type: "tel",
      label: "Phone Number",
      required: false,
      visible: true,
      dataName: `tel-${Date.now()}`,
      placeholder: "Enter phone number...",
    },
    date: {
      type: "date",
      label: "Date Picker",
      required: false,
      visible: true,
      dataName: `date-${Date.now()}`,
    },
    country: {
      type: "country",
      required: false,
      visible: true,
      label: "Country List",
      dataName: `country-${Date.now()}`,
      options: ["USA", "India", "Canada"],
    },
    file: {
      type: "file",
      label: "File Upload",
      required: false,
      visible: true,
      dataName: `file-${Date.now()}`,
    },
  };

  if (newField[type]) {
    console.log("Before setting, addedFields is:", addedFields);
    setAddedFields((prevFields) => {
      console.log("Inside setAddedFields, prevFields:", prevFields);
      if (Array.isArray(prevFields)) {
        const updatedFields = [...prevFields, newField[type]];
        console.log("Updated addedFields:", updatedFields);
        return updatedFields;
      } else {
        console.error("addedFields is not an array", prevFields);
        return [newField[type]];
      }
    });
  } else {
    console.error("Invalid field type:", type);
  }
};

  useEffect(() => {
    if (regFormSchema && Array.isArray(regFormSchema)) {
      const updatedDefaultFields = [...defaultFields]; 
      const newAddedFields = [];
  
      regFormSchema.forEach(field => {
        const regFormPrefix = field.dataName.split('-')[0]; 
        updatedDefaultFields.forEach((defaultField, index) => {
          const defaultPrefix = defaultField.dataName.split('-')[0]; 
  
          if (defaultPrefix === regFormPrefix) {
            updatedDefaultFields[index] = {
              ...defaultField,
              dataName: field.dataName,  
            };
          }
        });
        const isDefaultField = updatedDefaultFields.some(defaultField => {
          return defaultField.dataName === field.dataName;
        });
  
        if (!isDefaultField) {
          newAddedFields.push(field);
        }
      });
  
      setFields(updatedDefaultFields);  
      setAddedFields(newAddedFields); 
      newAddedFields.forEach(field => {
        dispatch(setFieldPayload(field));
      });
    }
  }, [regFormSchema, dispatch, setFields]);
  

  console.log(addedFields,"addedFields")

  const copyField = (index) => {
    const fieldToCopy = addedFields[index];
    let copiedField;
    if (fieldPayload?.length > 0) {
      const matchingPayload = fieldPayload.find(
        (item) => item.dataName === fieldToCopy.dataName
      );

      if (matchingPayload) {
        copiedField = {
          ...fieldToCopy,
          dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
          label: `copy ${fieldToCopy.label}`,
          value: "",
          isRequiredChecked: matchingPayload.required ?? false,
          isRequiredIf: matchingPayload.isRequiredIf ?? false,
          requiredFieldValue: matchingPayload.requiredFieldValue || "",
          requiredCondition:
            matchingPayload.requiredCondition || "Equals (Default)",
          requiredConditionValue: matchingPayload.requiredConditionValue || "",
          isVisibleChecked: matchingPayload.visible ?? true,
          isVisibleIfChecked: matchingPayload.isVisibleIf || false,
          visibleFieldValue: matchingPayload.visibleFieldValue || "",
          visibleCondition:
            matchingPayload.visibleCondition || "Equals (Default)",
          visibleConditionValue: matchingPayload.visibleConditionValue || "",
          selectedLabelPosition: matchingPayload.selectedLabelPosition || "top",
          selectedFieldSize: matchingPayload.selectedFieldSize || "100%",
          options: [...(matchingPayload.options || [])],
          includeOther: matchingPayload.includeOther ?? false,
          hoverHint: matchingPayload.hoverHint || "",
        };

        console.log(
          "Copied Field with conditions from fieldPayload:",
          copiedField
        );
        const copiedFieldPayload = {
          ...matchingPayload,
          dataName: copiedField.dataName,
          label: copiedField.label,
        };

        console.log("Dispatching Copied Field Payload:", copiedFieldPayload);
        dispatch(setFieldPayload(copiedFieldPayload));
      } else {
        copiedField = {
          ...fieldToCopy,
          dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
          label: `copy ${fieldToCopy.label}`,
          value: "",
        };
        console.log("Copied Field without matching conditions:", copiedField);
      }
    } else {
      copiedField = {
        ...fieldToCopy,
        dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
        label: `copy ${fieldToCopy.label}`,
        value: "",
      };
      console.log("Copied Field (fieldPayload is empty):", copiedField);
    }

    setCopiedFields((prevCopiedFields) => [...prevCopiedFields, copiedField]);
  };

 

  const removeField = (index) => {
    const fieldToRemove = addedFields[index];
    setAddedFields(addedFields.filter((_, i) => i !== index));
    dispatch(removeFieldFromPayload(fieldToRemove.dataName));
  };
  
  const removeFieldFromCopied = (index) => {
    const fieldToRemove = copiedFields[index];
    setCopiedFields(copiedFields.filter((_, i) => i !== index));
    dispatch(removeFieldFromPayload(fieldToRemove.dataName));
  };

  const fetchSavedForm = () => {
    if (!savedFormId) {
      alert("No saved form ID found.");
      return;
    }
    setShowSavedForm(true);
  };

  useEffect(() => {
    setFields([...defaultFields])
    setAddedFields();
  }, []);

  
 useEffect(() => {
  if (Array.isArray(fields) && Array.isArray(addedFields) && Array.isArray(copiedFields)) {
    const newFormSchema = [...fields, ...addedFields, ...copiedFields];
    console.log("Merged formSchema:", newFormSchema); // Debugging step
    setFormSchema(newFormSchema);
  }
  else if(formSchema.length === 0 ){
    setFormSchema([...fields])
  }
}, [fields, addedFields, copiedFields]);

const updateField = (updatedFields) => {
  const updatedFormFields = fields.map((field) => {
    const updatedField = updatedFields.find((updated) => updated.dataName === field.dataName);
    console.log(updatedFields,"asdasdasd")
    if (updatedField) {
      return { ...field, ...updatedField }; 
    }
    return field;
  });

  setFields(updatedFormFields);
};

const updateAddedField = (index, updatedField) => {
  setAddedFields((prevFields) => {
    const newFields = [...prevFields];
    newFields[index] = { ...newFields[index], ...updatedField };
    return newFields;
  });
};

const updateCopiedField = (updatedFieldData) => {
  const updatedCopiedFields = copiedFields.map((field) => {
    if (field.dataName === updatedFieldData.dataName) {
      return { ...field, ...updatedFieldData };
    }
    return field;
  });
  setCopiedFields(updatedCopiedFields);  
};

useEffect(() => {
  const initialData = formSchema.reduce((acc, field) => {
    acc[field.dataName] = {
      type:field.type,
      value: field.defaultValue || "",
      isConditionMet: true,
      isRequired: field.required || false,
      label: field.label,
      isVisible: field.visible || true,
      dataName: field.dataName || "",
      labelPosition:field.labelPosition || "",
      options:field.options || "",
      visible:field.visible ,
    };
    return acc;
  }, {});
  
  if (JSON.stringify(formData) !== JSON.stringify(initialData)) {
    setFormData(initialData);
  }
}, [formSchema]); 

console.log(formData, "daadaddaddadadadadda")

  useEffect(() => {
    const mergeFormDataWithPayload = () => {
      const updatedMergeData = { ...formData }; 
      fieldPayload.forEach(field => {
        const { dataName, ...rest } = field; 
        if (updatedMergeData[dataName]) {
          updatedMergeData[dataName] = {
            ...updatedMergeData[dataName], 
            ...rest, 
          };
        } else {
          updatedMergeData[dataName] = {
            value: '', 
            isConditionMet: true,
            isRequired: false,
            isVisible: true,
            ...rest, 
          };
        }
      });
  
      return updatedMergeData;
    };
  
    const updatedMergeData = mergeFormDataWithPayload();
    console.log("Mergeeeeeeeeee", updatedMergeData);
    if (JSON.stringify(formData) !== JSON.stringify(updatedMergeData)) {
      setFormData(updatedMergeData);
    }
  }, [fieldPayload, formData]); 

  console.log("formDataaaaa",formData)

  const saveForm = () => {
    if (!eventId) {
      console.error("Event ID is missing.");
      toast.error("registration Failed, EventId Missing")
      return;
    }
    const convertFormDataToArray = (formData) => {
      return Object.entries(formData).map(([key, value]) => {
          return {
              ...value, // Spread the properties of the value object
              dataName: key // Add the key as dataName
          };
      });
    };
    const formSchemaArray = convertFormDataToArray(formData);

    const formPayload = { form_schema: formSchemaArray, eventId , registrationFormId : registrationFormId};

    axios.put(`${EXCHNAGE_URL}/registrationFormUp`, formPayload,{
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((response) => {
        console.log(response)
        // dispatch({ type: SET_REGISTRATION_FORM_ID, payload: newRegistrationFormId });
        // setShowModal(true);
        toast.success("Registration Form Updated Successfully.")  
        dispatch(resetState());
        setAddedFields([]);
        setShowFormOne(true);
      })
      .catch((error) => {
        console.error("Error Updating form:", error);
        toast.error("Error Updating form. Please try again.");
      });
  };

  const handleClose = () => {
    setShowModal(false);     
  };

  const handleDragStart = (e, index, category) => {
    setDraggedIndex(index);
    setDraggedCategory(category);
    e.target.style.opacity = "0.5";
    e.target.style.cursor = "move";
  };

  const handleDragEnd = (e) => {
    e.target.style.opacity = "";
    e.target.style.cursor = "";
  };

  const handleDrop = (e, dropIndex, targetCategory) => {
    e.preventDefault();
    if (draggedCategory === targetCategory && draggedIndex === dropIndex) return;

    let sourceCategory;
    let targetCategoryState;
    let setState;
    if (draggedCategory === "fields") {
      sourceCategory = fields;
      targetCategoryState = [...fields];
      setState = setFields;
    } else if (draggedCategory === "addedFields") {
      sourceCategory = addedFields;
      targetCategoryState = [...addedFields];
      setState = setAddedFields;
    } else if (draggedCategory === "copiedFields") {
      sourceCategory = copiedFields;
      targetCategoryState = [...copiedFields];
      setState = setCopiedFields;
    }
    const [movedField] = targetCategoryState.splice(draggedIndex, 1);
    targetCategoryState.splice(dropIndex, 0, movedField);
    setState(targetCategoryState);

    setDraggedIndex(null);
    setDraggedCategory(null);
  };
  



  return (
    <div>
      <div className="formapp">
        <Side addField={addField} />
        <div className="canvas-save">
          <FormCanvas
            fields={fields}
            addedFields= {addedFields}
            updateField={updateField}
            updatedField={updatedField}
            removeField={removeField}
            copiedFields={copiedFields}
            disableRequiredCheckbox={true}
            formSchema={formSchema}
            copyField={copyField}
            removeFieldFromCopied={removeFieldFromCopied}
            updateAddedField={updateAddedField}
            updateCopiedField={updateCopiedField}
            handleDrop={handleDrop}
            handleDragStart={handleDragStart}
            handleDragEnd={handleDragEnd}

          />
          <div className="registratation_button">
            <GreyBackgroundButton onClick={() => setShowModal(true)}>Preview</GreyBackgroundButton>
            <RedBackgroundButton onClick={saveForm}>Update</RedBackgroundButton>
          </div>
        </div>
      </div>

      <FormPreview
      regFormSchema = {regFormSchema}
      formSchema={formSchema}
        showModal={showModal}
        handleClose={handleClose} // Close modal
      />

      {/* Show Saved Form */}
      {showSavedForm && savedFormId && (
        <SavedForm registrationFormId={savedFormId} eventId={eventId} />
      )}
    </div>
  );
};


export default UpdateRegistrationForm
